export default __webpack_public_path__ + "static/media/background-01.04e06052.png";